import React from 'react';
import './AlertStack.css';

const AlertStack = ({ alerts, onDismiss }) => {
  if (!alerts || alerts.length === 0) return null;

  return (
    <div className="alert-stack" aria-live="polite">
      {alerts.map((alert) => (
        <article key={alert.key} className={`alert-stack__item alert-stack__item--${alert.severity || 'info'}`}>
          <div className="alert-stack__top">
            <strong>{alert.title || 'Alerta'}</strong>
            <button type="button" onClick={() => onDismiss?.(alert.key)} aria-label="Fechar alerta">
              ×
            </button>
          </div>
          <p>{alert.message}</p>
          {(alert.ticketNumber || alert.customerName) && (
            <small>
              {alert.ticketNumber ? `#${alert.ticketNumber}` : ''}
              {alert.ticketNumber && alert.customerName ? ' · ' : ''}
              {alert.customerName || ''}
            </small>
          )}
        </article>
      ))}
    </div>
  );
};

export default AlertStack;
